import React from "react";

function Process() {
  return (
    <section id="process" className="tc-process-style1">
      <div className="container">
        <div className="title mb-100 text-center">
          <h2 className="fsz-45"> من الرؤية إلى الواقع</h2>
        </div>
        <div className="content">
          <div className="row">
            <div className="col-lg-5">
              <div className="info">
                <div
                  className="accordion wow fadeInUp slow"
                  id="accordionProcess"
                >
                  <div className="accordion-item">
                    <div className="accordion-header" id="headingOne">
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                      >
                        <span className="num"> 1 / </span>
                        <h3> الاستشارة وعروض الأسعار </h3>
                      </button>
                    </div>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse show"
                      data-bs-parent="#accordionProcess"
                    >
                      <div className="accordion-body">
                        <div className="text">
                          نبدأ رحلتنا بفهم رؤية العميل واحتياجاته من خلال مسح
                          ميداني دقيق وتقديم عروض أسعار شفافة تتناسب مع
                          الميزانية المحددة، مما يضع أساسًا قويًا لمشروع ناجح.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <div className="accordion-header" id="headingTwo">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                      >
                        <span className="num"> 2 / </span>
                        <h3> التصميم والتنفيذ </h3>
                      </button>
                    </div>
                    <div
                      id="collapseTwo"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionProcess"
                    >
                      <div className="accordion-body">
                        <div className="text">
                          في هذه المرحلة، يقدم فريقنا تصميمات مبتكرة ومدعومة
                          بتقنية الواقع الافتراضي، بما يتوافق مع المساحة ومعايير
                          الجودة. نتابع مع العميل كل خطوة لضمان تحقيق رؤيته.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <div className="accordion-header" id="headingThree">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                      >
                        <span className="num"> 3 / </span> <h3> التسليم </h3>
                      </button>
                    </div>
                    <div
                      id="collapseThree"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionProcess"
                    >
                      <div className="accordion-body">
                        <div className="text">
                          عند اكتمال المشروع، نجري مراجعة نهائية لضمان الجودة.
                          أثناء التسليم، نوضح التفاصيل النهائية ونتأكد من رضا
                          العميل عن النتيجة، وتسليم مساحة مطابقة للتصميم المتفق
                          عليه.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <a
                  href="#projects"
                  className="butn border nav-btn rounded-pill mt-80 color-primary-custom border-primary-custom hover-bg-primary-custom"
                >
                  <span>
                    جميع المشاريع
                    <i className="small ms-1 ti-arrow-top-right"></i>
                  </span>
                </a>
              </div>
            </div>
            <div className="col-lg-4 offset-lg-2">
              <div className="img wow">
                <img
                  src="/home1/assets/img/process.webp"
                  alt=""
                  className="img-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <img src="/home1/assets/img/c_line2.webp" alt="" className="c-line wow" />
    </section>
  );
}

export default Process;
